module.exports = __webpack_public_path__ + "images/logo.png";


//////////////////
// WEBPACK FOOTER
// ./public/logo.png
// module id = 2295
// module chunks = 0